// Utility to clear authentication data for testing
export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  console.log('Authentication data cleared from localStorage');
  window.location.reload();
};

// Add to window for easy access in browser console
if (typeof window !== 'undefined') {
  window.clearAuthData = clearAuthData;
}
